import { callable, mergeComponentVariables, withDebugId } from '@fluentui/styles';
var variablesCache = new WeakMap();
export var resolveVariables = function resolveVariables(displayNames, theme, variables, enabledVariablesCaching) {
  var componentThemeVariables;

  // Filter out components that doesn't have defined variables in theme
  var effectiveDisplayNames = displayNames.filter(function (displayName) {
    return !!theme.componentVariables[displayName];
  });

  //
  // Simple caching model, works only if there is no `props.variables`
  // Resolves variables for this component, cache the result in provider
  //

  if (enabledVariablesCaching) {
    if (!variablesCache.has(theme)) {
      variablesCache.set(theme, {});
    }
    var variablesThemeCache = variablesCache.get(theme) || {};

    // const displayNames = { Foo: variables, Bar: undefined, Baz: undefined }
    // This allows to avoid creating useless cache entries for `Bar` & `Baz` components
    var handlingDisplayName = effectiveDisplayNames[effectiveDisplayNames.length - 1];
    if (!variablesThemeCache[handlingDisplayName]) {
      // A short circle to avoid additional merging for non-composed components
      if (effectiveDisplayNames.length === 1) {
        variablesThemeCache[handlingDisplayName] = callable(theme.componentVariables[handlingDisplayName])(theme.siteVariables);
      } else {
        variablesThemeCache[handlingDisplayName] = effectiveDisplayNames.reduce(function (acc, displayName) {
          return mergeComponentVariables(acc, theme.componentVariables[displayName]);
        }, function () {
          return {};
        })(theme.siteVariables);
      }
      variablesCache.set(theme, variablesThemeCache);
    }
    componentThemeVariables = variablesThemeCache[handlingDisplayName];
  } else if (effectiveDisplayNames.length === 1) {
    componentThemeVariables = callable(theme.componentVariables[effectiveDisplayNames[0]])(theme.siteVariables) || {};
  } else {
    componentThemeVariables = effectiveDisplayNames.reduce(function (acc, displayName) {
      return mergeComponentVariables(acc, theme.componentVariables[displayName]);
    }, function () {
      return {};
    })(theme.siteVariables);
  }
  if (variables === undefined) {
    return componentThemeVariables;
  }
  return mergeComponentVariables(componentThemeVariables, withDebugId(variables, 'props.variables'))(theme.siteVariables);
};
//# sourceMappingURL=resolveVariables.js.map
